/** @jsx jsx */

// Packages
import { jsx, css } from '@emotion/react';

// Local
import classnames from 'classnames';
import { IconCtaArrow } from '../../Icons/IconCtaArrow';
import fallbackImage from '../../../../../../sites/_shared/assets/SF-GREEN.png';

// CSS
import '../../Result/article.css';

export function BlogCard({ cardProps }) {
  const { result, layout, className, controller, hideTitle, hideContent, blogRec, index } = cardProps;

	const lazy = index > 3 ? "lazy" : null;

  const core = result?.mappings?.core
	const content = result?.attributes?.content;
  const type = result?.attributes?.type;
	let title = core?.name;

	//Truncate blog posts with long names/descriptions
	//Only applies to recs
	if(blogRec == true && title?.length > 60) {
		title = title?.substring(0, 63) + "...";
	}

  //result.mappings.core.sku <-- This will help give you what type of content is being returned, if needed.
  
	//Metafield blog featured image - can be used to save MB for performance
  const blogfeaturedimgmetafield = result?.attributes?.blogfeaturedimgmetafield;
	const domain = window.Resources.domain;
	const metafieldPrefix = `//${domain}/cdn/shop/`;

  const imageUrl = blogfeaturedimgmetafield ? metafieldPrefix + blogfeaturedimgmetafield : core.imageUrl ? core.imageUrl : fallbackImage;
  const imageClass = imageUrl == fallbackImage ? 'ss__result__image-fallback' : '';

	return (
		<article
			className={classnames(
				'ss__result ss__result-article',
				typeof hoverImage != 'undefined' && 'ss__result__hover',
				`ss__result--${layout}`,
				className
			)}
		>
			<a
				href={core.url}
				onClick={(event) => {
					controller?.track?.product?.click(event, result);
					//IntelliSuggest?.clickItem(event, {siteId: IntelliSuggest?.siteId, intellisuggestData: result});
					//event.preventDefault();
					//console.log(controller?.track?.product?.click(event, result));
					//console.log(IntelliSuggest);
				}}
				className="ss__result-link"
				aria-label={core.name}
			>
				<div className="product-card-top-wrapper">
					<div className="ss__result__image-wrapper">
						<div className={classnames('ss__image', 'ss__result__image', `${imageClass}`)}>
							<img
								id={`ProductImage-${result.id}`}
								alt={core.name}
								class="product__img product__img--main lazyload"
								data-aspectratio="1.282258064516129"
								data-sizes="auto"
								data-image
								src={imageUrl}
								loading={lazy}
							/>
						</div>
					</div>
					<div className="ss__result__details">
						{!hideTitle && (
							<div
								className="ss__result__details__content-title"
								dangerouslySetInnerHTML={{
									__html: title,
								}}
							/>
						)}

						{!hideContent && (
							<div
								className="ss__result__details__content"
								dangerouslySetInnerHTML={{
									__html: content,
								}}
							/>
						)}
						<div className="ss__result__details__content-link button button--link-1">
							{window.Resources.searchspring.productCards.articleCardReadMore}
							<IconCtaArrow />
						</div>
					</div>
				</div>
			</a>
		</article>
	);
}
